import {
  applyMiddleware,
  compose,
  createStore,
} from 'redux'
import qs from 'qs'
import { routerMiddleware } from 'react-router-redux'
import { responsiveStoreEnhancer } from 'redux-responsive'
import thunk from 'redux-thunk'
import createRavenMiddleware from 'raven-for-redux'

import appConfig from './appConfig'
import history from './history'
import rootReducer from './reducer'
import saveUtmParams from './actions/saveUtmParams'

// Grab the state from a global variable injected into the server-generated HTML
const preloadedState = window.__PRELOADED_STATE__

// Allow the passed state to be garbage-collected
delete window.__PRELOADED_STATE__

const middleware = [
  thunk,
  routerMiddleware(history),
]

// Sentry error logging
if (process.env.NODE_ENV === 'production' && window.Raven) {
  window.Raven.config(process.env.REACT_APP_RAVEN_DSN).install()
  middleware.push(createRavenMiddleware(window.Raven, {}))
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const initialState = {
  appConfig: appConfig
}

const store = createStore(
  rootReducer,
  preloadedState || initialState,
  composeEnhancers(
    responsiveStoreEnhancer,
    applyMiddleware(...middleware)
  ),
)

// Extract UTM params and store for later use
const params = qs.parse(window.location.search, { ignoreQueryPrefix: true })

if (Object.keys(params).length > 0) {
  const allowed = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
  ]

  const filtered = Object.keys(params)
    .filter(key => allowed.includes(key))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: params[key]
      };
    }, {})

  store.dispatch(saveUtmParams(filtered))
}

export default store


// WEBPACK FOOTER //
// ./src/store.js